import { Events } from '|>/shared/events'
import { Intent } from '|>/shared/types/intent'
import { register } from '|>/shared/vjs'
import { BaseMuteToggle } from '../base'

@register
export class MuteToggle extends BaseMuteToggle {
  handleClickOriginal: undefined | ((event?: Event | undefined) => void)

  constructor(player, options) {
    super(player, options)
    this.requestAnimationFrame(() => this.update())

    // handleHotkeys() called by videoJs with BaseMuteToggle.prototype - so override doesnt work
    this.handleClickOriginal = BaseMuteToggle.prototype.handleClick
    BaseMuteToggle.prototype.handleClick = this.handleClick.bind(this)
    player.on('dispose', () => {
      if (this.handleClickOriginal) {
        BaseMuteToggle.prototype.handleClick = this.handleClickOriginal
      }
    })
  }

  override handleClick(event) {
    if (this.player_.hasClass('vjs-error')) {
      return
    }

    this.player_.trigger(Events.User.Intent, Intent.ToggleMute)
    this.player_.userActive(true)
    this.handleClickOriginal?.(event)
  }
}

MuteToggle.options = {
  className: 'vjs-x-mute-control',
}
